import * as types from "../consts";
import { ActivationPageReducer } from "../interfaces";

const initState = {
  isSetPasswordOk: null,
};

export default function setPasswordReducer(
  state = initState,
  action: ActivationPageReducer
) {
  switch (action.type) {
    case types.POST_SET_PASSWORD_REQUEST: {
      return { ...state, asyncReturned: false };
    }
    case types.POST_SET_PASSWORD_SUCCESS: {
      return {
        ...state,
        setPassword: action.response,
        isSetPasswordOk: true,
        asyncReturned: true,
      };
    }
    case types.POST_SET_PASSWORD_ERROR: {
      return { ...state, isSetPasswordOk: false, asyncReturned: true };
    }

    default: {
      return { ...state };
    }
  }
}
